import React, { Component } from 'react';
import { string } from '../../localization';
import { Icons } from '../../utilities';
import './RipChangeModal.scss';
import { Modal, ModalBody, Button } from 'reactstrap';
import ButtonWithImage from '../RipSelection/components/ButtonWithImage';
import TileView from '../TileView/TileView';
import { connect } from 'react-redux';
import * as pageControllerActions from '../../redux/pageControllerActions';
import * as gaHelpers from '../../utilities/GAHelpers/GAHelpers';
import * as Constants from '../../utilities/constants/Constants';
import { bindActionCreators } from 'redux';
import { savePrinitingOptionKey } from '../../utilities/CookieUtils/CookieUtils';
import { openLinkInNewTab } from '../../utilities/HelperFunctions/HelperFunctions';

class RipChangeModal extends Component {
  state = { ripIndex: null };

  getRipIndex = index => {
    this.setState({ ripIndex: index });
  };

  saveRipIndex = () => {
    const { ripIndex } = this.state;
    const { storeId, dispatchers } = this.props;
    savePrinitingOptionKey(ripIndex, storeId);
    dispatchers.pageControllerActions.setCurrentPageIndex(
      Constants.FINAL_CHECK_PAGE
    );
  };

  render() {
    const { page, dispatchers } = this.props;
    const { ripIndex } = this.state;
    return (
      <div>
        <Modal
          className='order-details-modal1'
          contentClassName='border-0 bg-transparent'
          centered
          isOpen={page === Constants.PRINT_PAGE}
        >
          <ModalBody className='rounded-0'>
            <div className='rip-change-modal'>
              <span className='close-icon'>
                <button
                  type='button'
                  onClick={() => {
                    dispatchers.pageControllerActions.setCurrentPageIndex(
                      Constants.FINAL_CHECK_PAGE
                    );
                  }}
                  style={{
                    width: '28px',
                    height: '28px',
                    border: 'none',
                    background: 'none',
                    outline: 'none'
                  }}
                  alt='close'
                >
                  <img
                    src={Icons.closeDefault}
                    alt='close'
                    style={{ marginLeft: '0px' }}
                  />
                </button>
              </span>
              <div className='rip-change-modal-body'>
                <div className='modal-head'>
                  <span className='modal-head-main select-your-preferred'>
                    {string.SELECT_PRINTING_OPTION_KEY}
                  </span>
                  <span className='modal-head-sub'>
                    {string.YOUR_SELECTION_WILL_KEY}
                  </span>
                </div>

                <div className='rip-modal-content'>
                  <div className='download-buttons'>
                    <div className='modal-buttons-top'>
                      <div>
                        <ButtonWithImage
                          imageUrl={Icons.hpCilck}
                          buttonLbl={Constants.HP_CLICK}
                          handleClick={() => this.getRipIndex(0)}
                          styles={
                            ripIndex == 0
                              ? styles.hpClickSelected
                              : styles.hpClick
                          }
                        />
                        <button
                          type='button'
                          className='download-link underline'
                          style={{
                            border: 'none',
                            background: 'none'
                          }}
                          onClick={() => {
                            openLinkInNewTab(Constants.LINK_HP_CLIK);
                            dispatchers.gaHelpers.gaOfHittingRipLink(
                              Constants.HP_CLICK
                            );
                          }}
                        >
                          {string.DOWNLOAD_LINK_KEY}
                        </button>
                      </div>
                      <div className='hpStreamImage'>
                        <ButtonWithImage
                          imageUrl={Icons.hpSmartStream}
                          buttonLbl={Constants.HP_SMART_STREAM_KEY}
                          handleClick={() => this.getRipIndex(1)}
                          styles={
                            ripIndex == 1
                              ? styles.hpStreamSelected
                              : styles.hpSmartStream
                          }
                          iconStyles={
                            ripIndex == 1
                              ? styles.hpSmartStreamImageSelected
                              : styles.hpSmartStreamImage
                          }
                        />
                        <span className='download-link'>
                          {string.DOWNLOAD_HP_SMARTSTREAM_KEY}
                          <button
                            type='button'
                            className='underline'
                            style={{
                              border: 'none',
                              background: 'none',
                              outline: 'none',
                              color: 'rgb(0, 150, 214)'
                            }}
                            onClick={() => {
                              openLinkInNewTab(Constants.LINK_HP_SMART_STREAM);
                              dispatchers.gaHelpers.gaOfHittingRipLink(
                                Constants.HP_SMART_STREAM_KEY
                              );
                            }}
                          >
                            {string.HERE_KEY}
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className='tile-view-container'>
                    <TileView
                      styles={styles.ripsBlockModal}
                      ripsTileView={styles.ripsTileView}
                      click={this.getRipIndex}
                      isRipSelected={ripIndex}
                    />
                  </div>
                </div>
              </div>
              <div className='rip-change-modal-footer'>
                <Button
                  className='rounded-0 border-0 cancel-btn'
                  // onClick={this.setState({ isOpen: false })}
                  onClick={() =>
                    dispatchers.pageControllerActions.setCurrentPageIndex(
                      Constants.FINAL_CHECK_PAGE
                    )
                  }
                >
                  {string.CANCEL_TEXT_KEY}
                </Button>
                <Button
                  className='rounded-0 border-0 apply-btn'
                  onClick={() => this.saveRipIndex()}
                >
                  {string.APPLY_KEY}
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const styles = {
  hpClick: {
    border: '1px solid lightgrey',
    width: '172px',
    height: '66px',
    borderRadius: '5px',
    backgroundColor: '#f8f8f8'
  },
  hpSmartStream: {
    border: '1px solid lightgrey',
    width: '210px',
    height: '66px',
    borderRadius: '5px',
    backgroundColor: '#f8f8f8'
  },
  hpSmartStreamImage: {
    width: '44px',
    height: '45px'
  },
  ripsBlockModal: {
    justifyContent: 'center',
    margin: 'auto',
    width: '80%'
  },
  ripsTileView: {
    width: '125px',
    height: '125px'
  },
  hpClickSelected: {
    backgroundColor: 'rgba(10,124,193,0.3)',
    border: '2px solid #0a7cc1',
    width: '172px',
    height: '66px',
    borderRadius: '5px',
    cursor: 'pointer',
    color: 'black'
  },
  hpStreamSelected: {
    border: '2px solid #0a7cc1',
    width: '210px',
    height: '66px',
    borderRadius: '5px',
    backgroundColor: 'rgba(10,124,193,0.3)',
    cursor: 'pointer',
    color: 'black'
  },
  hpSmartStreamImageSelected: {
    width: '44px',
    height: '45px'
  }
};

function mapStateToProps(state) {
  return {
    page: state.pageController.currentPageIndex,
    storeId: state.modal.storeData.id
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      pageControllerActions: bindActionCreators(
        pageControllerActions,
        dispatch
      ),
      gaHelpers: bindActionCreators(gaHelpers, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RipChangeModal);
